import { cx } from "../../lib/cx.js";
import { Button } from "../Button/Button.js";
import { GoogleLogo, MicrosoftLogo } from "./logos.js";
/* empty css              */
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/SSOButton/SSOButton.tsx
var PROVIDERS = {
	google: {
		label: "Sign in with Google",
		logo: GoogleLogo
	},
	microsoft: {
		label: "Sign in with Microsoft",
		logo: MicrosoftLogo
	}
};
/**
* A full-width provider sign-in button with the provider's official logo, or a partner
* site's name with a neutral icon. While `loading` it shows a spinner and "Signing in…"
* at the same width; disable the other providers' buttons meanwhile.
*/
var SSOButton = forwardRef(function SSOButton({ provider, partnerName, children, loadingText = "Signing in…", block = true, className, ...rest }, ref) {
	const partner = provider === "partner";
	const Logo = partner ? void 0 : PROVIDERS[provider].logo;
	return /* @__PURE__ */ jsx(Button, {
		ref,
		variant: "secondary",
		block,
		leadingIcon: Logo ? /* @__PURE__ */ jsx(Logo, {}) : "external-link",
		loadingText,
		className: cx("ds-sso-button", className),
		"data-provider": provider,
		...rest,
		children: children ?? (partner ? `Sign in with ${partnerName ?? "partner"}` : PROVIDERS[provider].label)
	});
});
//#endregion
export { SSOButton };

//# sourceMappingURL=SSOButton.js.map